import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StateService } from '../../../../../../state/state.service';
import { IdVerseViewState } from '../models/id-verse-content.model';
import { SKIP_PROMO_SESSION_KEY } from '../models/id-verse-content.data';

function getInitialState(): IdVerseViewState {
  return {
    currentFlowType: null,
    verificationUrl: null,
    skipMobileAppPromo: localStorage.getItem(SKIP_PROMO_SESSION_KEY) === 'true',
    failedAction: null,
  };
}

@Injectable()
export class IdVerseContentStateService extends StateService<IdVerseViewState> {

  constructor() {
    super(getInitialState());
  }

  getState$(): Observable<IdVerseViewState> {
    return this.select(state => state);
  }

  getSkipPromo(): boolean {
    return this.state.skipMobileAppPromo;
  }

  update(patch: Partial<IdVerseViewState>): void {
    if (patch.skipMobileAppPromo === true) {
      localStorage.setItem(SKIP_PROMO_SESSION_KEY, 'true');
    } else if (patch.skipMobileAppPromo === false) {
      localStorage.removeItem(SKIP_PROMO_SESSION_KEY);
    }
    this.setState(patch);
  }

  clearState(): void {
    this.initState(getInitialState());
  }
}
